import { render } from "./component-types.vue?vue&type=template&id=583f2e86&ts=true"
import script from "./component-types.vue?vue&type=script&lang=ts"
export * from "./component-types.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__